var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelSmartMesh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59426 16.7255C15.1593 10.1605 25.823 10.1605 32.388 16.7255C33.3284 17.6659 34.8543 17.6659 35.7947 16.7255C36.7351 15.7851 36.7351 14.2592 35.7947 13.3188C27.3489 4.89077 13.6334 4.89077 5.2053 13.3366C4.2649 14.277 4.2649 15.8029 5.2053 16.7433C6.14569 17.6837 7.67161 17.6837 8.612 16.7433L8.59426 16.7255ZM15.3899 23.5212C18.2111 20.7 22.7711 20.7 25.5923 23.5212C26.5327 24.4616 28.0586 24.4616 28.999 23.5212C29.9394 22.5808 29.9394 21.0549 28.999 20.1145C24.3148 15.4303 16.7029 15.4303 12.001 20.1145C11.0606 21.0549 11.0606 22.5808 12.001 23.5212C12.9414 24.4616 14.4673 24.4616 15.4077 23.5212H15.3899Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 26.6618C22.5226 26.6618 24.155 28.2941 24.155 30.3169C24.155 32.3396 22.5226 33.972 20.4999 33.972C18.4772 33.972 16.8448 32.3396 16.8448 30.3169C16.8448 28.2941 18.4772 26.6618 20.4999 26.6618Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelSmartMesh);
export default __webpack_public_path__ + "static/media/paltelSmartMesh.0af66b53031e5a7991cd9bdf2c0f3e25.svg";
export { ForwardRef as ReactComponent };